import { useState } from "react";


export const useRotaDoDiaState = () => {
  const [origin, setOrigin] = useState();
  const [destination, setDestination] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [idClient, setIdClient] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loader, setLoading] = useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [enabled, setEnabled] = useState(false);

  return {
    origin, setOrigin,
    destination, setDestination,
    modalOpen, setModalOpen,
    idClient, setIdClient,
    isLoading, setIsLoading,
    loader, setLoading,
    skip, setSkip,
    take, setTake,
    enabled, setEnabled
  };
};
